module.exports = __webpack_public_path__ + "static/media/swimmy-creation.1df7c95d.png";